module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('div', {
    staticClass: "my-account-component"
  }, [_c('h2', {
    staticClass: "my-account-head-caption"
  }, [_vm._v("My Account")]), _vm._v(" "), _c('div', {
    staticClass: "my-account-wrapper"
  }, [_c('form', {
    class: ['basic-info-form', {
      'basic-info-editable': _vm.isBasicInfoEditable
    }],
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveBasicInfo.apply(null, arguments)
      },
      "reset": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cancelBasicInfoEditing.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "basic-info-header"
  }, [_c('h3', [_vm._v("Basic info")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "disabled": _vm.isSaving || _vm.isSecurityInfoEditable
    },
    on: {
      "click": _vm.toggleBasicInfoEditableMode
    }
  }, [_c('md-icon', [_vm._v("edit")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right",
      "md-delay": "400"
    }
  }, [_vm._v("Edit")])], 1)], 1), _vm._v(" "), _c('md-input-container', {
    staticClass: "basic-info-input-readonly"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "disabled": _vm.isBasicInfoEditable,
      "readonly": ""
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1), _vm._v(" "), (_vm.isBasicInfoEditable) ? _c('p', {
    staticClass: "basic-info-email-message"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.isBasicInfoEditable) ? _c('md-input-container', {
    staticClass: "basic-info-input-readonly"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isBasicInfoEditable) ? _c('md-input-container', {
    class: {
      'md-input-invalid': !_vm.isNewNameValid
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "debounce": 500
    },
    on: {
      "input": _vm.validateFullName
    },
    nativeOn: {
      "input": function($event) {
        _vm.isNewNameValid = false
      }
    },
    model: {
      value: (_vm.newName),
      callback: function($$v) {
        _vm.newName = $$v
      },
      expression: "newName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.validationMessageOfNewName))])], 1) : _vm._e(), _vm._v(" "), (_vm.isBasicInfoEditable) ? _c('div', {
    staticClass: "basic-info-controls"
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isNewNameValid
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-default",
    attrs: {
      "type": "reset"
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1), _vm._v(" "), _c('form', {
    staticClass: "security-info-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveNewPassword.apply(null, arguments)
      },
      "reset": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isSecurityInfoEditable = false
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [(!_vm.isSecurityInfoEditable) ? _c('md-button', {
    staticClass: "md-primary security-info-reset-password-btn",
    attrs: {
      "disabled": _vm.isBasicInfoEditable || _vm.isSaving
    },
    on: {
      "click": _vm.togglePasswordChangeMode
    }
  }, [_vm._v("\n          Reset password\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isSecurityInfoEditable) ? _c('div', {
    staticClass: "security-info-passwords-wrapper"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': !!_vm.validationMessageOfOldPassword
    }
  }, [_c('label', [_vm._v("Old password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.oldPassword),
      callback: function($$v) {
        _vm.oldPassword = $$v
      },
      expression: "oldPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.validationMessageOfOldPassword))])], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': !_vm.isNewPasswordValid
    }
  }, [_c('label', [_vm._v("New password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "debounce": 600,
      "type": "password",
      "required": ""
    },
    on: {
      "input": _vm.validateNewPassword
    },
    nativeOn: {
      "input": function($event) {
        _vm.isNewPasswordValid = false
      }
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.validationMessageOfNewPassword))])], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': !_vm.arePasswordsSame
    }
  }, [_c('label', [_vm._v("Confirm new password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "debounce": 600,
      "type": "password",
      "required": ""
    },
    on: {
      "input": _vm.confirmNewPassword
    },
    nativeOn: {
      "input": function($event) {
        _vm.arePasswordsSame = false
      }
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.validationMessageOfConfirmePassword))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSecurityInfoEditable) ? _c('div', {
    staticClass: "security-info-controls"
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isReadyToSaveNewPassword
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-default",
    attrs: {
      "type": "reset"
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('md-button', {
    staticClass: "md-primary security-info-reset-password-btn",
    on: {
      "click": _vm.resetCredentials
    }
  }, [_vm._v("\n                Reset auth0 credentials\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-history-wrapper"
  }, [_c('h3', {
    staticClass: "login-history-header"
  }, [_vm._v("Login history")]), _vm._v(" "), (_vm.sortedLogs.length) ? _c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', {
    staticClass: "login-history-log-success"
  }, [_vm._v("Success")]), _vm._v(" "), _c('md-table-head', {
    staticClass: "login-history-log-action"
  }, [_vm._v("Action")]), _vm._v(" "), _c('md-table-head', {
    staticClass: "login-history-log-ip"
  }, [_vm._v("IP")]), _vm._v(" "), _c('md-table-head', {
    staticClass: "login-history-log-date"
  }, [_vm._v("When")])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.sortedLogs), function(log) {
    return _c('md-table-row', {
      key: log.id
    }, [_c('md-table-cell', {
      staticClass: "login-history-log-success"
    }, [(log.success) ? _c('md-icon', {
      staticClass: "login-history-success-icon"
    }, [_vm._v("check")]) : _c('md-icon', {
      staticClass: "login-history-failure-icon"
    }, [_vm._v("warning")]), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "left"
      }
    }, [_vm._v(_vm._s(log.success ? 'Success' : 'Failure'))])], 1), _vm._v(" "), _c('md-table-cell', {
      staticClass: "login-history-log-action"
    }, [_vm._v(_vm._s(log.action))]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "login-history-log-ip"
    }, [_vm._v(_vm._s(log.IP))]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "login-history-log-date"
    }, [_vm._v("\n              " + _vm._s(log.ago) + "\n              "), _c('md-tooltip', {
      attrs: {
        "md-direction": "right"
      }
    }, [_vm._v(_vm._s(log.date.toLocaleString()))])], 1)], 1)
  }), 1)], 1) : _c('div', {
    staticClass: "login-history-stub"
  }, [(!_vm.noLogsFound) ? _c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  }) : _c('p', {
    staticClass: "login-history-nothing-to-show"
  }, [_vm._v("Nothing to show yet...")])], 1)], 1)]), _vm._v(" "), _c('md-dialog', {
    ref: "credentialsDialog"
  }, [_c('md-dialog-title', [_vm._v("\n      Your new credentials\n    ")]), _vm._v(" "), _c('md-dialog-content', [_c('b', [_vm._v("Client ID:")]), _vm._v(" " + _vm._s(_vm.clientId)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Client Secret:")]), _vm._v(" " + _vm._s(_vm.clientSecret)), _c('br')]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    on: {
      "click": _vm.closeCredentialsDialog
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1) : _c('div', {
    staticClass: "my-account-loading"
  }, [_c('md-spinner', {
    attrs: {
      "md-size": 150,
      "md-indeterminate": ""
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_vm._v("Contact "), _c('a', {
    attrs: {
      "href": "mailto:support@widgetbrain.com"
    }
  }, [_vm._v("Widget Brain Support")]), _vm._v(" to update your email address.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "security-info-header"
  }, [_c('h3', [_vm._v("Security")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-674b8d2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyAccount.vue
// module id = 315
// module chunks = 2